import RegistrationCategoriesChooser from './RegistrationCategoriesChooser'

export default RegistrationCategoriesChooser
